export const GET_GALLERIES_BY_TYPE = "GET_GALLERIES_BY_TYPE";
export const GET_CAROUSEL = "GET_CAROUSEL";
export const GET_COLLECTION = "GET_COLLECTION";
export const GET_CATEGORY = "GET_CATEGORY";
export const GET_FOOTER = "GET_FOOTER";
export const GET_BANNER = "GET_BANNER";
export const GET_ADS = "GET_ADS";
